
import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { FinancialAssumptions } from './types';

interface BalanceSheetTabProps {
  assumptions: FinancialAssumptions;
  onInputChange: (section: keyof FinancialAssumptions, field: string, value: string | number) => void;
}

export function BalanceSheetTab({ assumptions, onInputChange }: BalanceSheetTabProps) {
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <Label htmlFor="cashProjection">Cash Projection (NZD)</Label>
          <Input
            id="cashProjection"
            type="number"
            value={assumptions.balanceSheet.cashProjection}
            onChange={(e) => onInputChange('balanceSheet', 'cashProjection', e.target.value)}
          />
        </div>
        <div>
          <Label htmlFor="arGrowth">Accounts Receivable Growth (%)</Label>
          <Input
            id="arGrowth"
            type="number"
            value={assumptions.balanceSheet.accountsReceivableGrowth}
            onChange={(e) => onInputChange('balanceSheet', 'accountsReceivableGrowth', e.target.value)}
          />
        </div>
        <div>
          <Label htmlFor="inventoryTurnover">Inventory Turnover (times/year)</Label>
          <Input
            id="inventoryTurnover"
            type="number"
            value={assumptions.balanceSheet.inventoryTurnover}
            onChange={(e) => onInputChange('balanceSheet', 'inventoryTurnover', e.target.value)}
          />
        </div>
        <div>
          <Label htmlFor="apGrowth">Accounts Payable Growth (%)</Label>
          <Input
            id="apGrowth"
            type="number"
            value={assumptions.balanceSheet.accountsPayableGrowth}
            onChange={(e) => onInputChange('balanceSheet', 'accountsPayableGrowth', e.target.value)}
          />
        </div>
        <div>
          <Label htmlFor="debtGrowth">Debt Growth Rate (%)</Label>
          <Input
            id="debtGrowth"
            type="number"
            value={assumptions.balanceSheet.debtGrowthRate}
            onChange={(e) => onInputChange('balanceSheet', 'debtGrowthRate', e.target.value)}
          />
        </div>
        <div>
          <Label htmlFor="equityProjection">Equity Projection (NZD)</Label>
          <Input
            id="equityProjection"
            type="number"
            value={assumptions.balanceSheet.equityProjection}
            onChange={(e) => onInputChange('balanceSheet', 'equityProjection', e.target.value)}
          />
        </div>
      </div>
    </div>
  );
}
